module.exports = __webpack_public_path__ + "static/img/66-2.d47598d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/66-2.jpg
// module id = gueS
// module chunks = 0